<div class="modal--container">
  <div class="modal-body">
    <div class="close-button--container">
      <div class="modal-title">Information required</div>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="close"
        ariaLabel="Close"
        (buttonClicked)="close()"
      ></app-mat-icon-button>
    </div>
    <form [formGroup]="infoForm" (ngSubmit)="buttonEventHandler()">
      <app-underlined-textarea-field
        [field]="infoField"
        [parentForm]="infoForm"
        [minLength]="minInfoLength"
        [maxLength]="maxInfoLength"
        rows="4"
        [showCharacterCounter]="true"
        labelSize="small"
      ></app-underlined-textarea-field>
      <div class="button--container">
        <app-button
          class="modal-button"
          buttonStyle="secondary"
          label="Cancel"
          buttonId="cancel-rejection"
          (buttonClicked)="close()"
          [isDisabled]="isProcessing"
        ></app-button>
        <app-button
          class="modal-button"
          buttonType="submit"
          buttonStyle="standard"
          label="Confirm rejection"
          buttonId="confirm-rejection"
          [isDisabled]="infoForm.invalid"
          [isProcessing]="isProcessing"
        ></app-button>
      </div>
    </form>
  </div>
</div>
<div class="modal--backdrop"></div>
